import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CommonUtils} from "../../utils/common";
import {AppStateService} from "../../providers/app-state.service";
import {InformationObligationAnswer} from "../../models/information-obligation-answer.model";
import {InformationObligationService} from "../../providers/information-obligation.service";

@Component({
  selector: 'app-generate-information-obligation',
  templateUrl: './generate-information-obligation.component.html',
  styleUrls: ['./generate-information-obligation.component.scss'],
})
export class GenerateInformationObligationComponent implements OnInit {

  @Input()
  informationObligationAnswers: InformationObligationAnswer;

  clinicName: string;
  informationObligationFormGroup: FormGroup;
  @Input()
  disableQuestions: boolean;
  isBusy: boolean;

  @Output()
  generateInformationObligationEmitter: EventEmitter<InformationObligationAnswer> = new EventEmitter<InformationObligationAnswer>();

  @Output()
  cancelGenerateInformationObligationEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  hasUnsavedChanges: boolean;

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.informationObligationAnswers && changes.informationObligationAnswers?.currentValue) {
      this.setupFields();
    }
  }

  constructor(private informationObligationService: InformationObligationService,
              private formBuilder: FormBuilder, public commonUtils: CommonUtils,
              private appStateService: AppStateService) {
  }

  ngOnInit() {
    this.appStateService.isBusySubject.subscribe(e => {
      this.isBusy = e;
    });

    this.setupFields();
  }

  submitTerms() {
    this.appStateService.updateIsBusySubject(true);
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zastosować powyższe zmiany w parametrach?',
      'Tak', 'Nie', 'checkmark', 'close', () => {
        this.informationObligationAnswers = this.commonUtils.formGroupValuesToObject<InformationObligationAnswer>(new InformationObligationAnswer(), this.informationObligationFormGroup);

        const emitValue: InformationObligationAnswer = this.informationObligationAnswers
        this.generateInformationObligationEmitter.emit(emitValue);

        this.appStateService.updateIsBusySubject(false);
      }, () => {
        this.appStateService.updateIsBusySubject(false);
      });
  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChanges = true;
    }
  }

  isFormFieldInvalid(group: any, fieldName: string, validationType: string) {
    return this.commonUtils.isFormFieldInvalid(group, fieldName, validationType);
  }

  onCancelAdd() {
    if (this.hasUnsavedChanges) {
      this.appStateService.updateIsBusySubject(true);
      this.commonUtils.presentYesNoActionSheet('Masz nie zapisane zmiany, czy chcesz je anulować?',
        'Tak', 'Nie', 'checkmark', 'close', () => {
          this.cancelGenerateInformationObligationEmitter.emit(true);
          this.appStateService.updateIsBusySubject(false);
        }, () => {
          this.appStateService.updateIsBusySubject(false);
        });
    } else {
      this.cancelGenerateInformationObligationEmitter.emit(true);
    }
  }

  private setupFields() {
    if (!this.informationObligationAnswers) {
      this.informationObligationFormGroup = this.formBuilder.group({
        clinicName: ['', Validators.required],
        clinicAddress: ['', Validators.required],
        clinicEmail: ['', [Validators.required, Validators.email]],
        clinicTaxId: ['', [Validators.minLength(10), Validators.maxLength(10), Validators.required,
          Validators.pattern("^[0-9]*$")]],
        clinicPhone: ['', Validators.required],
      });
    } else {
      this.informationObligationFormGroup = this.formBuilder.group({
        clinicName: [this.informationObligationAnswers.clinicName, Validators.required],
        clinicAddress: [this.informationObligationAnswers.clinicAddress, Validators.required],
        clinicEmail: [this.informationObligationAnswers.clinicEmail, [Validators.required, Validators.email]],
        clinicTaxId: [this.informationObligationAnswers.clinicTaxId, [Validators.minLength(10), Validators.maxLength(10), Validators.required,
          Validators.pattern("^[0-9]*$")]],
        clinicPhone: [this.informationObligationAnswers.clinicPhone, Validators.required],
      });
    }
  }


  numericOnly(event): boolean {
    const pattern = /^([0-9])$/;
    const result = pattern.test(event.key);
    return result;
  }

}
